import { parse as parseDate } from 'date-fns';
import { renderRichText } from '@storyblok/js';

export default function ({ _uid, _editable, globalNotification, items }) {
  const notificationParser = ({ ctaLabel, ctaLink, endDate, id, text, showCounter, creativeName, excludedPages }) => {
    return {
      id,
      text: renderRichText(text),
      label: ctaLabel,
      link: ctaLink,
      showCounter,
      creativeName,
      endDate: parseDate(endDate, 'yyyy-MM-dd HH:mm', new Date()),
      excludedPages
    };
  };

  return {
    _uid,
    _editable,
    globalNotification,
    items: items?.map(notificationParser)
  };
}
